import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getProjects, removeProject } from "./../../services/projectService";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import CustomLoader from "../common/Loader";
import ProjectDeleteDialog from "./ProjectDeleteDialog";
import { logActivity } from "../../services/utilService";

class Projects extends Component {
  state = {
    projects: [],
    loading: true,
  };

  async componentDidMount() {
    const { data: projects } = await getProjects();
    this.setState({ projects });
    this.setState({ loading: false });
  }

  handleDelete = async (pid) => {
    const { data } = await removeProject(pid);

    if (data.includes("Error")) {
      toaster('error', data);
      logActivity('/projects','PROJECT_DELETE_FAILED');
    } else {
      toaster('success', data);
      logActivity('/projects','PROJECT_DELETE_SUCCESS');
      let projects = this.state.projects.filter(
        (project) => project.Project_ID !== pid
      );
      this.setState({ projects });
    }
  };

  render() {
    if (this.state.loading) {
      return <CustomLoader loading={this.state.loading} />;
    }

    return (
      <div className="container">
        <div className="d-flex align-items-center justify-content-between mb-0 mt-5">
          <h2>Projects</h2>
          <button
            className="btn btn-outline-blue btn-sm rounded-0"
            onClick={() => {
              this.props.history.push("/projectSettings");
            }}
          >
            + New Project
          </button>
        </div>
        <hr className="mt-2 mb-4" />

        {this.state.projects.map((project, idx) => (
          <div
            className="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-primary h-100 mb-2"
            key={"project" + project.Project_ID}
          >
            <div className="card-body">
              <h5 className="card-title text-primary mb-2">
                <Link
                  to={{
                    pathname: "/projectSettings/",
                    Project_ID: project.Project_ID,
                    search: `?Project_ID=${project.Project_ID}`
                  }}
                >
                  {project.Project_Name}
                </Link>
              </h5>
              <p className="card-text">{project.Project_Description}</p>

              <div className="d-flex align-items-center justify-content-between">
                Created By: {project.CreatedBy}
                <ProjectDeleteDialog
                  key={"deleteProj" + idx}
                  Project={project}
                  handleDelete={this.handleDelete}
                />
              </div>
            </div>
          </div>
        ))}

        {/* <div className="card card-icon mb-4">
          <div className="row no-gutters">
            <div className="col-auto card-icon-aside bg-primary">
              <button
                className="btn btn-blue"
                onClick={() => {
                  this.props.history.push("/projectSettings");
                }}
              >
                + New Project
              </button>
            </div>
            <div className="col">
              <div className="card-body py-5">
                <div className="card border-top-0 border-bottom-0 border-right-0 border-left-lg border-primary h-100">
                  <div className="card-body">
                    <h5 className="card-title text-primary mb-2">
                      Project Name
                    </h5>
                    <p className="card-text">Project Description</p>
                    <div className="float-right">
                      <button className="btn btn-outline-danger rounded-0">
                        Delete
                      </button>
                    </div>
                  </div>
                  <div className="card-footer">Owner</div>
                </div>
                <table className="table table-hover table-borderless">
                  <thead className="border-bottom">
                    <tr>
                      <th>Project ID</th>
                      <th>Project Name</th>
                      <th>Created By</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.projects.map((project) => (
                      <tr key={project.Project_ID} className="border-bottom">
                        <td>{project.Project_ID}</td>
                        <td>
                          <Link
                            to={{
                              pathname: "/projectSettings/",
                              Project_ID: project.Project_ID,
                            }}
                          >
                            {project.Project_Name}
                          </Link>
                        </td>
                        <td>{project.CreatedBy}</td>
                        <td className="text-center">
                          <button
                            onClick={() =>
                              this.handleDelete(project.Project_ID)
                            }
                            className="btn btn-outline-danger btn-sm"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
       */}
        <ToastContainer/>
      </div>
    );
  }
}

export default Projects;
